import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, Spin } from "antd";
import { sortBy } from "lodash";
import { useEffect, useRef } from "react";
import { IoPerson } from "react-icons/io5";
import { useUserPresenceStore } from "../../../store/useUserPresenceStore";
import { showName } from "../../../utils/Utils";
import { useDirectoryContext } from "./DirectoryContext";
import "./style.scss";

const Organization = ({ onlyView, isForwardMail }) => {
  const { tree, searchResult, setSearchResult, isTreeLoading } =
    useDirectoryContext();

  const organizationRef = useRef(null);

  useEffect(() => {
    if (searchResult?.length) {
      organizationRef?.current[searchResult?.[0]?.objectId]?.scrollIntoView();
      setSearchResult([]);
    }
  }, [tree]);

  return (
    <div
      ref={organizationRef}
      className={`org ${isForwardMail ? "h-[589px]" : ""}`}
    >
      {sortBy(tree, ["position"])?.map((item) => (
        <div
          ref={(el) => {
            if (organizationRef?.current)
              return (organizationRef.current[item?.objectId] = el);
          }}
          key={item?.id}
        >
          <Subtree
            onlyView={onlyView}
            item={item}
            key={item?.id}
            organizationRef={organizationRef}
          />
        </div>
      ))}
      {isTreeLoading && (
        <div className="absolute top-[50%] w-full text-center">
          <Spin indicator={<LoadingOutlined classID="text-[35px]" spin />} />
        </div>
      )}
    </div>
  );
};

const Subtree = ({ item, onlyView, organizationRef }) => {
  const { openFolder, onClickCheckBox, onClickFolder } = useDirectoryContext();
  const status =
    useUserPresenceStore((state) => state.userStatuses?.[item?.userCode]) ||
    "OFFLINE";

  return (
    <div
      className="subtree text-[14px]"
      ref={(el) => {
        if (organizationRef && organizationRef.current)
          return (organizationRef.current[item?.objectId] = el);
      }}
    >
      <div
        className="parent cursor-pointer"
        onClick={() => onClickFolder(item)}
      >
        {!onlyView && (
          <Checkbox
            onClick={(e) => onClickCheckBox(e, item)}
            checked={item?.checked}
            indeterminate={item?.indeterminate}
          />
        )}
        {item?.type === "INSTITUTION" ? (
          openFolder(item)
        ) : (
          <IoPerson size={20} color={`${item?.online ? "#24832c" : "black"}`} />
        )}
        {item?.type !== "INSTITUTION" && (
          <div
            onClick={(e) => onClickCheckBox(e, item)}
            className={
              item?.highlight
                ? "text-[#eda30f] flex flex-col"
                : "text-[black] flex flex-col "
            }
          >
            <span>
              {showName(item?.name)}
              <span className="ml-1 text-[#2a55b9]">
                {showName(item?.userPosition, 20)}
              </span>
            </span>
            <span className="text-[#2a55b9]">{showName(item?.phone)}</span>
            <div className="text-[#2a55b9]">{showName(item?.mood)}</div>
          </div>
        )}
      </div>
      <div className="children">
        {item?.isOpen &&
          sortBy(item?.children, ["position"])?.map((i) => (
            <Subtree
              item={i}
              openFolder={openFolder}
              key={i?.id}
              onClickCheckBox={onClickCheckBox}
              onlyView={onlyView}
              organizationRef={organizationRef}
            />
          ))}
      </div>
    </div>
  );
};
export { Organization };
